import React, {Component} from 'react'
import SkuInfo from './SkuInfo'
import SkuSize from './sizes/SkuSize'
import SkuActions from './SkuActions'
import {Card, CardBody} from "reactstrap"
import {editSku, getInfoSku, updateMaterials, getShippingCarrierSku, getProductionProcess, getListBrandSku, getListTab} from '../../../services/api/apiSku'
import PropTypes from "prop-types"
import {message, Input} from "antd"
import HistoryPage from "./history/HistoryPage"
import SkuAddCarrier from "./SkuAddCarrier"
import PubSub from "pubsub-js"
import {getLocalData} from "../../../services/StorageServices";
import {parseJwt} from "../../../share/parseToken";
import { getListPartner } from '../../../services/api/3dApi'
import { getListBrands } from '../../../services/api/apiBrands'
import SkuAddBrand from './SkuAddBrand'
import ProductionStructure from './productionStructure/ProductionStructure'
import { Link } from 'react-router-dom'
import { v4 as uuidV4 } from 'uuid'

class SkuDetailPage extends Component {
    state = {
        name: '',
        sku: '',
        procedure: '2D',
        export_by: '',
        is_active: false,
        flow: '',
        materials: '',
        description: '',
        loading: false,
        error: '',
        validateName: '',
        changeList: [],
        listShipping: [],
        commitment_time: '',
        validateTime: '',
        need_manage_materials: false,
        packed_description: '',
        is_mex: false,
        listPartner: [],
        listProductionProcess: [],
        production_process:'',
        partner: '',
        validatePartner: '',
        meta: '',
        commitment_time_fast_production: '',
        validateTimeFast: '',
        is_embroidery: false,
        embroidery_position: [],
        brandOptions: [],
        listBrand: [],
        listTab: [],
        package_mockup: [],
        layerConfig: null,
        brands_description_packaged: [
            {
                brand: '',
                description: '',
                images: [],
                isChange: false,
                isLoading: false,
                idx: uuidV4(),
            }
        ],
    }

    _subscription = null

    componentDidMount() {
        this._getDetailSku()
        // this._getShippingCarrier()
        this._getProductProcess()
        this._getPartner()
        this._getBrandOptions()
        this._getListTab()
        // this._getListBrand()
        // this._subscription = PubSub.subscribe('GET_LIST_SHIPPING_CARIER', this._getShippingCarrier)
        // this._subscription = PubSub.subscribe('GET_LIST_BRAND', this._getListBrand)
        this._subscription = PubSub.subscribe('GET_LIST_TAB', this._getListTab)
    }

    _getListTab = async () => {
        const {id} = this.props
        try {
            const {data} = await getListTab(id)
            const {data: listTab, success} = data

            if (!success) return
            this.setState({
                listTab: listTab
            })
        } catch (e) {
        }
    }

    _getShippingCarrier = async () => {
        const {id} = this.props
        try {
            const {data} = await getShippingCarrierSku(id)
            const {data: listShipping, success} = data
            if (!success) return
            this.setState({
                listShipping
            })
        } catch (e) {
        }
    }

    _getBrandOptions = async () => {
        const payload = {
            page: 1,
            limit: 10000,
        }

        try {
            const { data, success } = await getListBrands(payload)
            const { Brands } = data
            if (!success) return

            const listOption = Brands.map(item => {
                const itemOption = {
                    value: item.name,
                    name: item.name
                }

                return itemOption
            })
            this.setState({
                brandOptions: listOption
            })
        } catch (e) {
        }
    }

    _getListBrand = async () => {
        const {id} = this.props
        try {
            const {data} = await getListBrandSku(id)
            const {data: listBrand, success} = data
            if (!success) return
            this.setState({
                listBrand
            })
        } catch (e) {
        }
    }

    _getProductProcess = async () => {
        const payload={
            page:1,
            limit:10000,
        }
        try {
            const {data:res} = await getProductionProcess(payload)
            const {data, success} = {...res}
            const {result} = {...data}

            if (!success) return
            this.setState({
                listProductionProcess: result
            })
        } catch (e) {
        }
    }

    _getPartner = async () => {
        const payload = {
            page: 1,
            limit: 10000,
            hidden: false,
        }
        try {
            const { data, success } = await getListPartner(payload)
            const { partners: listPartner } = data
            if (!success) return

            this.setState({
                listPartner
            })
        } catch (e) {
        }
    }

    _handleValidateInfo = () => {
        const {name, commitment_time, partner, commitment_time_fast_production, production_process} = this.state

        if (name === '') {
            this.setState({
                validateName: 'Tên SKU là bắt buộc!'
            })

            return false
        } else if (commitment_time === '' || commitment_time === null || +commitment_time < 0) {
            this.setState({
                validateTime: 'Thời gian cam kết là bắt buộc và là số dương!'
            })

            return false
        }else if (+commitment_time_fast_production < 0) {
                        this.setState({
                validateTimeFast: 'Thời gian cam kết nhanh phải là số dương!'
            })

            return false
        }else if (partner === '' || partner === null) {
            this.setState({
                validatePartner: 'Bắt buộc chọn partner sản xuất!'
            })

            return false
        } else {
            this.setState({
                validateName: '',
                validateTime: '',
                validatePartner: '',
                validateTimeFast: '',
            })

            return true
        }
    }

    _getDetailSku = async () => {
        const {id} = this.props
        this.setState({
            loading: true,
            error: ''
        })
        
        try {
            const {data: response} = await getInfoSku(id)
            const {success, data, error} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error: error
                })
            }

            const {
                name, sku, procedure, 
                export_by, is_active, meta,
                flow, materials, description, 
                commitment_time, need_manage_materials, 
                packed_description, is_mex, partner,
                commitment_time_fast_production, is_embroidery, embroidery_info,
                production_process, package_mockup = [], brands_description_packaged = [],
                has_layer_config = false, white_print = false, layers = []
            } = data

            const {embroidery_position} = Object.assign({}, embroidery_info)
            const embroideryPositionArray = !!embroidery_position && Object.entries(embroidery_position).map(([key, value]) => ({
                side: key,
                order: value.order
            }))

            const newBrandsDescriptionPackaged = !!brands_description_packaged.length && brands_description_packaged.every(i => (!!i.brand && !!i.description)) ?
                brands_description_packaged.map(i => ({
                    brand: !!i.brand ? i.brand : '',
                    description: !!i.description ? i.description : '',
                    images: !!i.images ? i.images : [],
                    isChange: false,
                    isLoading: false,
                    idx: uuidV4(),
                })) : [
                    {
                        brand: '',
                        description: '',
                        images: [],
                        isChange: false,
                        isLoading: false,
                        idx: uuidV4(),
                    }
                ]

            this.setState({
                loading: false,
                error: '',
                flow: flow || '',
                materials: materials || '',
                description: description || '',
                name,
                sku,
                procedure,
                export_by,
                is_active,
                commitment_time,
                need_manage_materials,
                packed_description,
                is_mex, 
                partner: partner ? partner.id : '',
                meta: meta,
                commitment_time_fast_production,
                is_embroidery,
                embroidery_position: embroideryPositionArray.length > 0 ? embroideryPositionArray : [{side: '', order: 1}],
                production_process: production_process ? production_process._id : '',
                package_mockup,
                brands_description_packaged: newBrandsDescriptionPackaged,
                layerConfig: {has_layer_config, white_print, layers}
            })
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        }

    }

    _handleChangeInfo = (name, value) => {
        if(name === "commitment_time_fast_production"){
            const reg = /^-?\d*(\.\d*)?$/;
            if (reg.test(value) || value === '' || value === '-') {
                this.setState({
                    [name]: value
                }, () => {
                    const checking = this._handleValidateInfo()
        
                    if (checking) {
                        const {changeList} = this.state
                        const change = changeList.includes(name)
        
                        if (changeList.length === 0 || !change) {
                            this.setState({
                                changeList: [...changeList, name]
                            })
                        }
                    }
                })
            }
        }else{
            this.setState({
                [name]: name === 'materials' ? (typeof value === 'string' && value.toUpperCase()) : value
            }, () => {
                const checking = this._handleValidateInfo()
    
                if (checking) {
                    const {changeList} = this.state
                    const change = changeList.includes(name)
    
                    if (changeList.length === 0 || !change) {
                        this.setState({
                            changeList: [...changeList, name]
                        })
                    }
                }
            })
        }
    }

    _onUpdateSku = async () => {
        const {
            name, procedure, export_by,
            is_active, flow, description, 
            commitment_time, need_manage_materials, 
            packed_description, is_mex, partner,
            commitment_time_fast_production, embroidery_position, is_embroidery,
            production_process, package_mockup, brands_description_packaged
        } = this.state
        const {id} = this.props
        const embroidery_position_payload = embroidery_position.filter(i => i.side).reduce((arr, item) => {
            if(Object.keys(arr).includes(!!item.side && item.side.trim())) return {
                err: 'Vị trí thêu không được trùng nhau.'
            }
            arr[item.side] = {
                order: item.order
            }
            return arr
        },{})

        if (this._handleValidateInfo()) {
            this.setState({
                loading: true,
                error: ''
            })

            try {
                const payload = {
                    procedure: !!procedure ? procedure : '2D',
                    flow: !!flow ? flow : '',
                    description: description,
                    name,
                    export_by,
                    is_active,
                    commitment_time,
                    need_manage_materials,
                    packed_description,
                    is_mex, partner,
                    commitment_time_fast_production,
                    is_embroidery,
                    production_process,
                    package_mockup,

                }

                if(is_embroidery) {
                    if(!!embroidery_position_payload.err) {
                        this.setState({
                            loading: false
                        })
                        return {error : embroidery_position_payload.err}
                    }
                    payload.embroidery_position = embroidery_position_payload
                }

                if(!!brands_description_packaged.length && brands_description_packaged.every(i => (!!i.brand && !!i.description))){
                    const newBrandsDescriptionPackaged = brands_description_packaged.map(b => {
                        const {idx, isChange, isLoading, ...rest} = Object.assign({}, b)
                        return rest
                    }) || []

                    payload.brands_description_packaged = newBrandsDescriptionPackaged
                }
                
                const {data: response} = await editSku(id, payload)
                const {success, message: error} = response

                if (!success) {
                    this.setState({
                        loading: false,
                    })
                    return {error}
                }

                this.setState({
                    loading: false,
                    error: ''
                })
            } catch (e) {
                this.setState({
                    loading: false,
                    error: e.message
                })
            }
        }
    }

    _onUpdateMaterials = async () => {
        const {materials} = this.state
        const {id} = this.props

        this.setState({
            loading: true,
            error: ''
        })

        try {
            const payload = {
                materials
            }

            const {data: response} = await updateMaterials(id, payload)
            const {success, message: error} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error: error
                })
            }

            this.setState({
                loading: false,
                error: ''
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    _handleClickUpdate = async (e) => {
        e.preventDefault()

        const {changeList} = this.state
        const request = []
        const changeSku = changeList.filter(item => !['materials'].includes(item))

        if (changeList.includes('materials')) {
            request.push(this._onUpdateMaterials())
        }

        if (changeSku.length > 0) {
            request.push(this._onUpdateSku())
        }

        if (request.length) {
            const data = await Promise.all(request) || []
            if(data.some(i => !!i && !!i.error)){
                const err = data.find(i => !!i && !!i.error)
                return message.error(err.error)
            } 
            await this._getDetailSku()
            message.success('Cập nhật thông tin thành công.')
            PubSub.publish('GET_HISTORY')
        }

        this.setState({
            changeList: [],
        })
    }

    hanldeAddConfigEmbroidery = (order) => {
        const {embroidery_position} = this.state
        const itemEmbroidery = embroidery_position.length > 0 ? embroidery_position.find(i => i.order === order) : {}
        if((!!itemEmbroidery && !itemEmbroidery.side) || embroidery_position.length > 49) return
        this.setState({
            embroidery_position : [
                ...embroidery_position,
                {
                    side: '',
                    order: order + 1
                }
            ]
        }, () => {
            const {changeList} = this.state
            const change = changeList.includes('embroidery_position')

            if (changeList.length === 0 || !change) {
                this.setState({
                    changeList: [...changeList, 'embroidery_position']
                })
            }
        })
    }

    hanldeDeleteConfigEmbroidery = (order) => {
        const {embroidery_position} = this.state
        const newEmbroideryPosition = embroidery_position.map(i => {
            if(i.order !== order) {
                return {
                    ...i,
                    order: i.order <= order ? i.order : i.order - 1
                }
            }
        }).filter(Boolean)
        this.setState({
            embroidery_position: newEmbroideryPosition
        }, () => {
            const {changeList} = this.state
            const change = changeList.includes('embroidery_position')

            if (changeList.length === 0 || !change) {
                this.setState({
                    changeList: [...changeList, 'embroidery_position']
                })
            }
        })
    }

    hanldeChangeEmbroidery = (value, order) => {
        const {embroidery_position} = this.state
        const newEmbroideryPosition = embroidery_position.map(i => {
            if(i.order === order) {
                return {
                    ...i,
                    side: value
                }
            }
            return i
        })
        this.setState({
            embroidery_position: newEmbroideryPosition
        }, () => {
            const {changeList} = this.state
            const change = changeList.includes('embroidery_position')

            if (changeList.length === 0 || !change) {
                this.setState({
                    changeList: [...changeList, 'embroidery_position']
                })
            }
        })
    }

    hanldeMakeEmbroidery = () => {
        const {embroidery_position} = this.state
        const newEmbroideryPosition = embroidery_position.filter(i => !!i.side)
        this.setState({
            embroidery_position: newEmbroideryPosition.length > 0 ? newEmbroideryPosition : [{side: '', order: 1}]
        })
    }

    handleAddImageDescribe = (imageUrl) => {
        const { package_mockup = [] } = this.state
        this.setState({
            package_mockup: [...package_mockup, imageUrl]
        }, () => {
            const checking = this._handleValidateInfo()

            if (checking) {
                const { changeList } = this.state
                const change = changeList.includes("package_mockup")

                if (changeList.length === 0 || !change) {
                    this.setState({
                        changeList: [...changeList, "package_mockup"]
                    })
                }
            }
        })
    }

    handleRemoveImageDescribe = (imageUrl) => {
        const { package_mockup = [] } = this.state
        const newPackageMockup = package_mockup.filter((item) => item !== imageUrl)
        this.setState({
            package_mockup: newPackageMockup
        }, () => {
            const checking = this._handleValidateInfo()

            if (checking) {
                const { changeList } = this.state
                const change = changeList.includes("package_mockup")

                if (changeList.length === 0 || !change) {
                    this.setState({
                        changeList: [...changeList, "package_mockup"]
                    })
                }
            }
        })
    }

    _handleChangeBrandsDescriptionPackaged = (data) => {
        this.setState({brands_description_packaged: data})
    }

    render() {
        const {id} = this.props
        const {
            loading,
            error,
            name,
            sku,
            procedure,
            export_by,
            is_active,
            flow,
            materials,
            description,
            validateName,
            changeList,
            commitment_time,
            validateTime,
            need_manage_materials,
            packed_description,
            is_mex,
            listPartner,
            partner,
            validatePartner,
            meta,
            commitment_time_fast_production,
            validateTimeFast,
            is_embroidery,
            embroidery_position,
            listProductionProcess,
            production_process,
            brandOptions,
            listTab,
            package_mockup,
            brands_description_packaged,
            layerConfig
        } = this.state
        const token = getLocalData('accessToken')
        const user = token !== '' && parseJwt(token).permissions ? parseJwt(token).permissions : {}
        const isFFMView = user.hasOwnProperty('base_cost_management')

        return (
            <div className="SkuDetailPage">
                <Card>
                    <div className="CardHeader card-header header-elements-inline">
                        <h1 className='card-title font-weight-bold d-flex align-items-center'>
                            <Link to={'/sku-manager'} className="txt-16"><i className="fa fa-chevron-left mr-2 mt-2" /></Link>
                            Sửa sản phẩm - {sku}
                        </h1>
                        {error && <div className="mt-3 text-danger">{error}</div>}
                    </div>

                    <CardBody>
                        <SkuInfo
                            skuID={id}
                            loading={loading}
                            packageMockup={package_mockup}
                            error={error}
                            validateName={validateName}
                            validateTime={validateTime}
                            validatePartner={validatePartner}
                            name={name}
                            sku={sku}
                            procedure={procedure}
                            export_by={export_by}
                            is_active={is_active}
                            flow={flow}
                            materials={materials}
                            description={description}
                            commitment_time={commitment_time}
                            onChange={this._handleChangeInfo}
                            need_manage_materials={need_manage_materials}
                            packed_description={packed_description}
                            is_mex={is_mex}
                            listPartner={listPartner}
                            partner={partner}
                            meta={meta}
                            commitment_time_fast_production={commitment_time_fast_production}
                            is_embroidery={is_embroidery}
                            onMakeEmbroidery={this.hanldeMakeEmbroidery}
                            listProductionProcess={listProductionProcess}
                            production_process={production_process}
                            onAddImageDescribe={this.handleAddImageDescribe}
                            onRemoveImageDescribe={this.handleRemoveImageDescribe}
                            brandOptions={brandOptions || []}
                            brandsDescriptionPackaged={brands_description_packaged}
                            onChangeBrandsDescriptionPackaged={this._handleChangeBrandsDescriptionPackaged}
                            actionUpdate={this._onUpdateSku}
                            getDetailSku={this._getDetailSku}
                        />

                        {
                            is_embroidery &&
                            <div className="embroidery-priority border w-50 mb-3">
                                <h4 className='font-weight-bold mb-0'>Vị trí thêu và độ ưu tiên</h4>
                                {
                                    embroidery_position.length > 0 && (
                                        <div className="embroidery-priority-items">
                                            {
                                                embroidery_position.sort((a, b) => a.order - b.order).map((item, i) => (
                                                    <div className="embroidery-priority-item m-2" key={`${item}_${i}`}>
                                                        <div className='label-item'>Vị trí {item.order}</div>
                                                        <Input 
                                                            style={{width: 300}}
                                                            value={item.side}
                                                            onChange={(e) => this.hanldeChangeEmbroidery(e.target.value, item.order)}
                                                        />
                                                        {i > 0 && <i className="icon-bin text-danger cursor-pointer ml-2" onClick={() => this.hanldeDeleteConfigEmbroidery(item.order)}/>}
                                                        {i === embroidery_position.length -1 && <i className="icon-plus-circle2 text-success cursor-pointer ml-2" onClick={() => this.hanldeAddConfigEmbroidery(item.order)}/>}
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    )
                                }
                            </div>
                        }

                        <ProductionStructure skuID={id} isSkuSaved={!!sku} config={layerConfig} loading={loading}/>

                        <div className="d-flex justify-content-between align-items-center info-detail-head">
                            <h3 className="font-weight-bold">Thông tin chi tiết</h3>
                            <div className='d-flex justify-content-between align-items-center'>
                                <SkuAddBrand skuID={id} brandOptions={brandOptions} listTab={listTab}/>
                                <SkuAddCarrier skuID={id} listTab={listTab}/>
                            </div>
                        </div>

                        <SkuSize skuID={id} isFFMView={isFFMView} brandOptions={brandOptions} listTab={listTab}/>

                        <SkuActions
                            changeList={changeList}
                            commitmentTime={commitment_time}
                            validateName={validateName}
                            validateTime={validateTime}
                            validatePartner={validatePartner}
                            loading={loading}
                            actionUpdate={this._handleClickUpdate}
                            validateTimeFast={validateTimeFast}
                            embroideryPosition={embroidery_position}
                            isEmbroidery={is_embroidery}
                        />

                        <hr/>

                        <HistoryPage id={id}/>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

SkuDetailPage.propTypes = {
    id: PropTypes.string.isRequired,
}

export default SkuDetailPage
